
import { Component, OnInit } from '@angular/core';
import { ConfirmationService } from 'primeng/api';
import { FormControl, FormGroup, FormGroupDirective, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiServiceService } from 'src/app/api-service.service';
import { AppUtility } from 'src/app/interceptor/apputitlity';
import { md5 } from 'src/md5';

@Component({
  selector: 'app-checker-assign',
  templateUrl: './checker-assign.component.html',
  styleUrls: ['./checker-assign.component.scss']
})

export class CheckerAssignComponent implements OnInit {
  filterval: string;
  dateFilterVal: string;

  constructor(private _apiService: ApiServiceService, private activate: ActivatedRoute, private route: Router, public _utility: AppUtility, private confirmService: ConfirmationService) { }
  errorMessage: string = ''
  errorMessageCheck: string = ''
  userArray: any;
  invalidEmail: boolean = false;
  submitButton: string = 'Submit'

  budata: any = [];
  checker2list: any = []
  selectedchecker2: any = []
  //formGroup
  userRegisterFormControl = new FormGroup({
    bu: new FormControl('', [Validators.required]),
    checker2: new FormControl('', [Validators.required]),
  },
    [AppUtility.MatchValidator('password', 'confirmPassword')]
  )


  ngOnInit(): void {
    this.getRegisteredUser();
    this.getBUdata();
    this.loadChecker2Data();
  }

  breadcrumb = [
    {
      title: 'Assign Checker',
      subTitle: 'Dashboard'
    }
  ]

  //Login Supplier
  registerUser(signup: FormGroupDirective) {
    console.log(this.userRegisterFormControl.value, this.userRegisterFormControl.valid);
    if (this.userRegisterFormControl.valid) {
      this._utility.loader(true);
      if (this.submitButton == 'Submit') {
        const signUpObject = {
          buMasterId: this.userRegisterFormControl.get('bu')?.value,
          checker2Ids: this.userRegisterFormControl.get('checker2')?.value,
          clientId: 1
        };

        console.log('Payload to send:', signUpObject);
        this._apiService.checkerassign(signUpObject)
          .then((res: any) => {
            this._utility.loader(false);
            if (res.success == false) {
              window.scroll(0, 0);
              this.errorMessage = res.message
              this.errorMessageCheck = 'error'
              this._apiService.showMessage(this.errorMessage, this.errorMessageCheck)
            }

            else {
              this.errorMessage = res.message
              this.errorMessageCheck = 'success'
              this._apiService.showMessage(this.errorMessage, this.errorMessageCheck);
              this.userRegisterFormControl.reset();
              Object.keys(this.userRegisterFormControl.controls).forEach(key => {
                this.userRegisterFormControl.controls[key].setErrors(null);
              });
              signup.resetForm();
            }
            this.getRegisteredUser();
          })
      }


    }

    else {
      this._utility.loader(false);
      this.errorMessage = 'Please fill form details'
      this.errorMessageCheck = 'error'
      this._apiService.showMessage(this.errorMessage, this.errorMessageCheck);
    }
  }


  invalidMobile: boolean = false;
  phone: string = ''
  //validate user mobile number
  validateMobile(event: any) {
    this.invalidMobile = this._utility.validateMobile(event);
  }

  getRegisteredUser() {
    this._apiService.getcheckerAssignlist().then((res: any) => {
      this.userArray = res.data.data.map((user: any) => ({
        ...user,
        checker2Names: user.checker2List.map((c2: any) => c2.checker2Name).join(', ')
      }));

      console.log(this.userArray, "checker flattened");
    });

    this.submitButton = 'Submit';
  }


  editUserId: any;
  Editpassword: any;
  EditItem(customer: any) {
    console.log(customer);
    this.Editpassword = customer.loginPassword;
    this.userRegisterFormControl.controls["emailAddress"].setValue(customer["loginName"]);
    this.userRegisterFormControl.controls["isActive"].setValue(customer["isActive"]);
    this.userRegisterFormControl.controls["name"].setValue(customer["userName"]);
    this.userRegisterFormControl.controls["mobile_no"].setValue(customer["mobileNo"]);
    this.userRegisterFormControl.controls["address"].setValue(customer["address"]);
    this.userRegisterFormControl.controls["userRole"].setValue(customer["roleName"]);
    this.userRegisterFormControl.controls["password"].setValue('testL@123');
    this.userRegisterFormControl.controls["confirmPassword"].setValue('testL@123');
    this.userRegisterFormControl.controls["checker"].setValue(customer.checker1 ? 'checker1' : customer.checker2 ? 'checker2' : '');
    this.editUserId = customer.loginId;
    this.submitButton = 'Update';
  }

  setActive() {
    this.userRegisterFormControl.reset();
    this.userRegisterFormControl.controls['isActive'].setValue(true);
    this.userRegisterFormControl.controls['bu'].setValue('');
    this.submitButton = 'Submit'
  }

  reset(dt2) {
    dt2.reset();
    this.filterval = '';
    this.dateFilterVal = ''
  }
  getBUdata() {
    this._apiService
      .dropdowndata("BUMaster")
      .then((res: any) => {
        if (res.success == true) {
          this.budata = res.returnValue;
        } else {
          this.budata = [];
        }
      })
      .catch((err: any) => {
        this.budata = [];
      });
  }
  async loadChecker2Data(): Promise<void> {
    try {
      const res = await this._apiService.getchecker2details();
      console.log('API Response:', res);
      this.checker2list = res.returnValue;

    } catch (err) {
      console.error('API Error:', err);
    }
  }
  onDescriptionSelected(selectedValues: any[]): void {
    console.log('Selected Items:', selectedValues);
    this.selectedchecker2 = selectedValues;
    console.log(this.selectedchecker2);

  }

  confirm1(id: any) {
    this.confirmService.confirm({
      message: 'Are you sure you want to delete this assignment?',
      header: 'Delete Confirmation',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.deleteItem(id);
      },
      reject: () => { }
    });
  }

  deleteItem(id: any) {
    this._apiService.deleteAssign(id).then((res: any) => {
      if (res.returnCode == 200) {
        this._apiService.showMessage(res.message, 'success');
        this.getRegisteredUser();
      } else {
        this._apiService.showMessage(res.message, 'error');
      }
    }).catch(err => {
      this._apiService.showMessage('An error occurred while deleting.', 'error');
    });
  }
}

